import React, { ReactChild, ChangeEvent } from "react";
import { Switch, Route, RouteComponentProps } from "react-router-dom";

import { V1 } from "../../Api";

import { COPY_YEAR } from "../../Const";

import HCWHLogo from "../../images/hcwh_logo_white_small_notext.png";
import TWCLogo from "../../images/twc_white.png";

import "../../css/form.css";
import "../../css/list.css";
import "../../css/checkbox.css";

interface IStatementLookupPageState {
    isLookingUpStatement: boolean | string;
    isStatementNotFound: boolean;

    accountNumber: string;
    accessCode: string;
}

class StatementLookupPage extends React.Component<RouteComponentProps<any>, IStatementLookupPageState> {
    constructor(props: Readonly<RouteComponentProps<any>>) {
        super(props);

        this.state = {
            isLookingUpStatement: false,
            isStatementNotFound: false,

            accountNumber: "",
            accessCode: ""
        };

        this.formInputChanged = this.formInputChanged.bind(this);
        this.lookupStatement = this.lookupStatement.bind(this);
    }

    public componentDidMount() {
        document.title = "UOG - Pay Your Bill Online";
    }

    public componentWillUnmount() {
    }

    public render() {
        const { match } = this.props;

        let content = <form className="form-root" onSubmit={e => { e.preventDefault(); return false; }}>
            <Switch>
                <Route>
                    <h1 className="no-top-margin">Pay Your Bill Online</h1>
                    <p>
                        Thank you for using United Obstetrics and Gynecology!  To pay your bill online,
                        please enter your account number and access code from the statement you received.
                    </p>
                    <div className="input-group">
                        <label htmlFor="account-number">Account Number</label>
                        <input type="tel" id="account-number"
                            name="accountNumber" value={this.state.accountNumber}
                            onChange={this.formInputChanged} autoComplete="off_please" autoFocus={true} />
                    </div>
                    <div className="input-group">
                        <label htmlFor="access-code">15 digit access code</label>
                        <span className="inline-note">With or without the dashes</span>
                        <input type="tel" id="access-code"
                            name="accessCode" value={this.state.accessCode}
                            onChange={this.formInputChanged} autoComplete="off_please" />
                    </div>
                    {this.state.isLookingUpStatement === true
                        ? <p>Looking up your statement...</p>
                        : typeof this.state.isLookingUpStatement === "string"
                            ? <div className="error-box slim">{this.state.isLookingUpStatement}</div>
                            : null}
                    {this.state.isStatementNotFound === true
                        ? <p>
                            The statement could be found.  Please double-check the numbers and try again.<br />
                            If you continue to have problems, please call us at <a href="tel:12293913500">(229) 391-3500</a>
                        </p>
                        : null}
                    <p>
                        <button type="button" className="button" onClick={this.lookupStatement} disabled={!this.state.accessCode || !this.state.accountNumber || this.state.isLookingUpStatement === true}>Find my statement</button>
                    </p>
                </Route>
            </Switch>
        </form>;

        return <>
            <header>
                <img src={HCWHLogo} alt="Howard Center Logo" />
                <img src={TWCLogo} alt="Tifton Woman's Center Logo" />
            </header>
            {content}
            <footer className="footer-version">
                <small>&copy; {COPY_YEAR} United Obstetrics and Gynecology</small>
                <small> &mdash; <a href="http://www.thehowardcenter.com/Polterm/UOG%20Terms%20And%20Conditions%20Paperless%20Statements.pdf" target="_blank" rel="noopener noreferrer">Terms</a> &mdash; <a href="http://www.thehowardcenter.com/Polterm/UOG%20Financial%20Privacy%20Policy.pdf" target="_blank" rel="noopener noreferrer">Privacy</a></small>
                <small> &mdash; Payment services provided through <a href="https://braintreepayments.com" target="_blank" rel="noopener noreferrer">Braintree</a></small>
            </footer>
        </>;
    }

    private handleBeforeUnload(e: Event) {
        if (true/*!this.state.hasBegun*/) {
            return;
        }

        //e.preventDefault();
        //e.returnValue = true;

        //return true;
    }

    //private goBack() {
    //    let count = 1;
    //    if (this.props.history.location.state?.backSkipCount) {
    //        count = this.props.history.location.state?.backSkipCount;
    //    }

    //    this.props.history.go(-count);
    //}

    private formInputChanged(event: ChangeEvent<HTMLInputElement>) {
        const name = event.currentTarget.name;
        const value = event.currentTarget.type === "checkbox" ? event.currentTarget.checked : event.currentTarget.value;

        this.setState({
            [name]: value
        } as any);
    }

    private async lookupStatement() {
        try {
            this.setState({
                isLookingUpStatement: true,
                isStatementNotFound: false,
            });

            const accountNumber = this.state.accountNumber.replace(/[^0-9]/g, "");
            const accessCode = this.state.accessCode.replace(/[^0-9]/g, "");
            const statementInfo = await V1.get<any>(`statement/lookup/${accountNumber}/${accessCode}`);

            this.setState({
                isLookingUpStatement: false,
            });

            // Redirect to statement
            this.props.history.push(`/${statementInfo.code}`);
        }
        catch (e) {
            if (e.statusCode === 404) {
                this.setState({
                    isLookingUpStatement: false,
                    isStatementNotFound: true,
                });
                return;
            }

            this.setState({
                isLookingUpStatement: e.message || "Could not look up statement.  Please try again later"
            });
        }
    }
}

export function PaymentSuccess() {
    return <>
        <header>
            <img src={HCWHLogo} alt="Howard Center Logo" />
            <img src={TWCLogo} alt="Tifton Woman's Center Logo" />
        </header>
        <div className="form-root">
            <h1 className="no-top-margin">Payment Accepted</h1>
            <p>
                You're all done!  Your payment has been accepted and is being processed.<br />
                Thank you for being a United Obstetrics and Gynecology patient!
            </p>
            <p>
                You can now close this page.
            </p>
        </div>
        <footer className="footer-version">
            <small>&copy; {COPY_YEAR} United Obstetrics and Gynecology</small>
            <small> &mdash; Payment services provided through <a href="https://braintreepayments.com" target="_blank" rel="noopener noreferrer">Braintree</a></small>
        </footer>
    </>;
}

export default StatementLookupPage;
